import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-400 py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <p className="text-sm">{t('footer.copyright')}</p>
          </div>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6 items-center">
            <a 
              href="https://methodmate.ai/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#1E88E5] transition-colors text-sm min-h-[44px] flex items-center"
            >
              {t('footer.about')}
            </a>
            <a 
              href="https://methodmate.ai/contact/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#1E88E5] transition-colors text-sm min-h-[44px] flex items-center"
            >
              {t('footer.contact')}
            </a>
            <a 
              href="https://methodmate.ai/terms-2/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#1E88E5] transition-colors text-sm min-h-[44px] flex items-center"
            >
              {t('footer.terms')}
            </a>
            <a 
              href="https://methodmate.ai/privacypolicy/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#1E88E5] transition-colors text-sm min-h-[44px] flex items-center"
            >
              {t('footer.privacy')}
            </a>
            <Link 
              to="/admin" 
              className="text-gray-600 hover:text-gray-400 transition-colors text-sm min-h-[44px] flex items-center"
            >
              {t('footer.admin')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
